function showModal(title, message, path = undefined) {
  let url = window.location.pathname
  if (typeof path !== 'undefined') {
    url = path
  }
  let $modal = $(`
      <div class="modal fade">
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">${title}</h5>
            </div>
            <div class="modal-body">
              <p>
                ${message}
              </p>
            </div>
            <div class="modal-footer">
              <a href="${url}" class="btn btn-primary">Zurück</a>
            </div>
          </div>
        </div>
      </div>
    `)
  let $backdrop = $(`<div class="modal-backdrop fade"></div>`)

  $modal.appendTo('body').show()
  $backdrop.appendTo('body').show()

  setTimeout(() => {
    $modal.addClass('show')
    $backdrop.addClass('show')
  })
}

module.exports = {
  showModal: showModal
}
